module.exports = __webpack_public_path__ + "static/media/notf-sound.818ac467.ogg";